import React from 'react';
import ReactDOM from 'react-dom/client';

import { AppProviders } from '@/AppProviders.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AppProviders />
  </React.StrictMode>
);
